"use client";
import {
  tabs_default
} from "./chunk-25S546L6.mjs";
import "./chunk-MGHLJVLI.mjs";
import "./chunk-JXBG24BW.mjs";
import {
  useTabs
} from "./chunk-73H64UCB.mjs";
import {
  tab_item_base_default
} from "./chunk-FXLYF44B.mjs";
export {
  tab_item_base_default as Tab,
  tabs_default as Tabs,
  useTabs
};
